import useCubeItems, { PageType } from '../hooks/useCubeItems/useCubeItems'
import CubePageTemplate from '../CubePageTemplate/CubePageTemplate'

const Home = () => {
  const items = useCubeItems(PageType.PREVIEW)

  return <CubePageTemplate items={items} isPreviewMode />
}

export default Home
